import React from 'react';
import './App.css';
import 'antd/dist/antd.css';
import RouterOutlet from './routing/router-outlet';
import Helper from './library/helper';
import { CssType } from './theme/jss-types';
import GenericHoc from './common/generic-hoc';
import { HocOptions } from './common/generic-hoc.types';
import Loader from './common/Loader';
import { loadInitialData } from './common/actions/loadInitialData';
import { loginRoute, vehicleRequestsRoute } from './routing/routeConstants';
import { INITIALIZE_COMPLETE } from 'src/common/actions/constants';
import authHelper from './auth/auth-helper';
import SideDrawer from 'src/common/SideDrawer/SideDrawer';
import config from 'src/globals';
import PersistentIframe from './components/persistent-iframe/persistentIframeInjector';
import { IframeApps } from './components/persistent-iframe/persistent-iframe.constants';
import TicketManagement from './components/Ticket-managment/ticketManagement';
import { getCustomFrontendApps } from './components/custom-frontend/customFrontendManifest';

const styles = (): CssType => ({
  mainDiv: {
    height: '100%',
    direction: (props: any) => Helper.languageDirection(props.i18n.language),
  },
  contentDiv: {
    height: '100%',
  },
});

const App = (props: any) => {
  const { fetchingData, classes, dispatch, history, location, showTicketingTool } = props;

  const [primaryColor, setPrimaryColor] = React.useState('');
  const updatePrimaryColor = () => {
    (window as any).less.modifyVars({
      '@primary-color': primaryColor,
    });
  };
  const initiatePrimaryColor = () => {
    (window as any).less.modifyVars({
      '@primary-color': '#065492',
    });
  };
  React.useEffect(() => {
    const storage = window.localStorage;
    initiatePrimaryColor();
    if (fetchingData && authHelper.isAuthenticated()) {
      if (location.pathname === '/login' || location.pathname === '/') {
        history.replace(vehicleRequestsRoute);
      }
      dispatch(loadInitialData());
    } else if (location.pathname === '/login/resetPassword') {
      dispatch({ type: INITIALIZE_COMPLETE });
    } else {
      dispatch({ type: INITIALIZE_COMPLETE });
      history.replace(loginRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fetchingData) {
    return <Loader />;
  }

  return (
    <div className={classes.mainDiv}>
      <div className={classes.contentDiv}>
        <RouterOutlet />
      </div>
      <SideDrawer />
      <PersistentIframe appName={IframeApps.Analytics} />
      {getCustomFrontendApps().map((a) => (
        <PersistentIframe key={a.appId} appName={a.appId} />
      ))}
      {showTicketingTool ? <TicketManagement /> : null}
      {/* DON'T REMOVE THIS, REQUIRED FOR GENERIC BULK UPLOAD SERVICE */}
      <div id='generic-bulk-upload-service-container' />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { initializing, masterData } = state;
  const { show_ticketing_tool } = masterData;
  return {
    fetchingData: initializing,
    showTicketingTool: show_ticketing_tool,
  };
};

const hocConfig: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
  },
  connectJss: {
    useJss: true,
    styleSheet: styles,
  },
  connectRouter: true,
  connectTranslession: true,
};
export default GenericHoc(hocConfig)(App);
